var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPyramidIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2833 7.25H8.71667L11.0468 2.5892C11.4395 1.8036 12.5605 1.8036 12.9532 2.5892L15.2833 7.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09155 10.5006L7.96675 8.75H16.0331L17.7829 12.25H11.437C10.2961 11.1838 8.77079 10.5238 7.09155 10.5006Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1536 22H20.9329C21.7251 22 22.2404 21.1662 21.8861 20.4575L21.0325 18.75H13.2617C12.9021 20.0394 12.1549 21.1673 11.1536 22Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4953 17.25H20.2826L18.5329 13.75H12.6304C13.1835 14.7061 13.5 15.8161 13.5 17C13.5 17.0837 13.4984 17.1671 13.4953 17.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22C4.23858 22 2 19.7614 2 17C2 14.2386 4.23858 12 7 12C9.76142 12 12 14.2386 12 17C12 19.7614 9.76142 22 7 22ZM7.53033 14.4697C7.23744 14.1768 6.76256 14.1768 6.46967 14.4697L3.46967 17.4697C3.17678 17.7626 3.17678 18.2374 3.46967 18.5303C3.76256 18.8232 4.23744 18.8232 4.53033 18.5303L7 16.0607L9.46967 18.5303C9.76256 18.8232 10.2374 18.8232 10.5303 18.5303C10.8232 18.2374 10.8232 17.7626 10.5303 17.4697L7.53033 14.4697Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyramidIncrease);
export default __webpack_public_path__ + "static/media/pyramid-increase.bae16c9af169130f79ba516e72c60462.svg";
export { ForwardRef as ReactComponent };